/*
 * Fantastic Framing – shared collapsible (accordion) element
 * <ff-collapsible class="ff-collapsible ff-collapsible--desktop ff-collapsible--mobile [is-open]">
 * Desktop = 990px and up, tablet & mobile = below 990px (Broadcast "large" breakpoint).
 * Content stays in the page HTML (good for SEO); it is only visually collapsed.
 */
(function () {
  if (customElements.get('ff-collapsible')) return;

  var desktopQuery = window.matchMedia('(min-width: 990px)');

  class FFCollapsible extends HTMLElement {
    connectedCallback() {
      this.toggleButton = this.querySelector(':scope > .ff-collapsible__toggle, :scope > * > .ff-collapsible__toggle');
      if (!this.toggleButton) return;
      this.panel = document.getElementById(this.toggleButton.getAttribute('aria-controls'));
      if (!this.panel) return;

      this.onClick = this.onClick.bind(this);
      this.update = this.update.bind(this);
      this.onEditorSelect = this.onEditorSelect.bind(this);

      this.toggleButton.addEventListener('click', this.onClick);
      if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', this.update);
      else desktopQuery.addListener(this.update);

      // Theme editor: open the block when it is selected in the sidebar
      document.addEventListener('shopify:block:select', this.onEditorSelect);

      this.update();
    }

    disconnectedCallback() {
      if (!this.toggleButton) return;
      this.toggleButton.removeEventListener('click', this.onClick);
      if (desktopQuery.removeEventListener) desktopQuery.removeEventListener('change', this.update);
      else desktopQuery.removeListener(this.update);
      document.removeEventListener('shopify:block:select', this.onEditorSelect);
    }

    isActive() {
      return desktopQuery.matches
        ? this.classList.contains('ff-collapsible--desktop')
        : this.classList.contains('ff-collapsible--mobile');
    }

    isOpen() {
      return this.classList.contains('is-open');
    }

    setOpen(open) {
      this.classList.toggle('is-open', open);
      this.update();
      if (!open) {
        // Stop any playing HTML5 video inside a closed panel
        this.panel.querySelectorAll('video').forEach(function (v) { try { v.pause(); } catch (e) {} });
      }
    }

    onClick(event) {
      event.preventDefault();
      this.setOpen(!this.isOpen());
    }

    onEditorSelect(event) {
      if (this.contains(event.target) || event.target.contains(this)) this.setOpen(true);
    }

    // Keep ARIA/focus state in sync with the current breakpoint
    update() {
      var active = this.isActive();
      var open = this.isOpen();
      this.toggleButton.setAttribute('aria-expanded', active ? String(open) : 'true');
      if (active && !open) {
        this.panel.setAttribute('inert', '');
      } else {
        this.panel.removeAttribute('inert');
      }
    }
  }

  customElements.define('ff-collapsible', FFCollapsible);
})();
